import League from "../entities/League.js";
import ResultsSlice from "../valueObjects/ResultsSlice.js";

class RankingStatCaseVerifier {
    constructor(leagueClassifier, sessionClassifier, sliceClassifier) {
        if (typeof(sessionClassifier) !== 'function') {
            throw new TypeError('sessionClassifier must be an predicate function taking single parameter as an input, it will be session object');
        }
        this.sessionClassifier = sessionClassifier;

        if (typeof(leagueClassifier) !== 'function') {
            throw new TypeError('leagueClassifier must be an predicate function taking single parameter as an input, it will be League class instance');
        }
        this.leagueClassifier = leagueClassifier;

        if (typeof(sliceClassifier) !== 'function') {
            throw new TypeError('sliceClassifier must be an predicate function taking single parameter as an input, it will be ResultsSlice class instance');
        }
        this.sliceClassifier = sliceClassifier;
    }

    situationMatches(session, league, slice) {
        return this.sessionMatches(session)
            && this.leagueMatches(league)
            && this.sliceMatches(slice)
        ;
    }

    sessionMatches(session) {
        if (!session || typeof(session) !== 'object') {
            throw new TypeError('session must be an non empty object');
        }
        return this.sessionClassifier(session);
    }

    leagueMatches(league) {
        if (!league || !(league instanceof League)) {
            throw new TypeError('league must be an instance inheriting from League class');
        }
        return this.leagueClassifier(league);
    }

    sliceMatches(slice) {
        if (!(slice instanceof ResultsSlice)) {
            throw new TypeError('slice must be an instance inheriting from ResultsSlice class');
        }
        return this.sliceClassifier(slice);
    }
}

export default RankingStatCaseVerifier;